// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: 6,
    }
};

var artImg = $('#article-img').data('artimg');

bcSfFilterSettings.general.limit = (artImg != undefined) ? 11 : 12;
// Declare Templates
var bcSfFilterTemplate = {
    'soldOutClass': 'sold-out',
    'saleClass': 'on-sale',
    'soldOutLabelHtml': '<div>' + bcSfFilterConfig.label.sold_out + '</div>',
    'saleLabelHtml': '<div>' + bcSfFilterConfig.label.sale + '</div>',
    'vendorHtml': '<div>{{itemVendorLabel}}</div>',
	
    // Grid Template
'productGridItemHtml': '<div class="collection-card" data-master-variant="{{itemIsMasterVariant}}">' +
                                '<div class="product-image">' +
                                  '<a href="{{itemUrl}}" title="{{itemTitle}}" class="coll-url">{{productImage}}</a>' +
  								  '{{imgNewIcon}}' +
                                '</div>' +
                                '<div class="product-type">' +
                                    '<p>{{dataType}}</p>' +
                                '</div>' +
                                '<div class="product-name">' +
                                    '<a href="{{itemUrl}}">{{itemTitle}}</a>' +
                                '</div>' +
                                '<div class="product-description">' +
    								'<p>{{itemMetadata}}</p>' +
                                '</div>' +
                                '<div class="product-price">' +
                                    '<p>{{itemPrice}}</p>' +
                                    '<span>/ {{productVariantTitle}}</span>' +
                                '</div>' +
                                '<div class="add-to-cart" data-id="{{productId}}" data-inc="{{itemQty}}" data-ic="{{itemCount}}">' +
                                    '{{productButton}}' +
                                '</div>' +
                                '<div class="wishlist" data-id="{{productId}}" data-url="{{dataUrl}}" data-count="{{itemCount}}" data-img="{{itemThumbUrl}}" data-price="{{dataPrice}}" data-mid="{{dataMasterId}}">' +
                                    '<a href="javascript:void(0)">' +
                                        '<i class="far fa-heart"></i>' +
                                    '</a>' +
                                '</div>' +
                            '</div>',
    // Pagination Template
    'previousActiveHtml': '<li><a href="{{itemUrl}}">&larr;</a></li>',
    'previousDisabledHtml': '<li class="disabled"><span>&larr;</span></li>',
    'nextActiveHtml': '<li><a href="{{itemUrl}}">&rarr;</a></li>',
    'nextDisabledHtml': '<li class="disabled"><span>&rarr;</span></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li><span class="active">{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
    'paginateHtml': '<ul class="pagination-custom">{{previous}}{{pageItems}}{{next}}</ul>',
  
    // Sorting Template
    'sortingHtml': '<label class="label--hidden">' + bcSfFilterConfig.label.sorting + '</label><select class="collection-sort__input">{{sortingItems}}</select>',
};

/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
  
    /*** Prepare data ***/
    var images = data.images_info;
    data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100;
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
      }
      console.log("BCSF product data:", data);
    /*** End Prepare data ***/
 /*** Add custom metafields ***/



// Read metafields injected by Liquid
var shortDescription = '';
var isMasterFromLiquid = null;

var metaEl = $('.metafields-data[data-product-id="' + data.id + '"]');

if (metaEl.length) {
    shortDescription = metaEl.data('metadata') || '';
    isMasterFromLiquid = metaEl.data('is-master');
}

// Attach to data object
data.short_description = shortDescription;

if (isMasterFromLiquid !== null && data.is_master_variant === undefined) {
    data.is_master_variant = isMasterFromLiquid;
}

// Wait until the page fully loads
window.addEventListener('load', function() {
    var collectionCards = document.querySelectorAll('div.collection-card');

    collectionCards.forEach(function(card) {
        var masterAttr = card.getAttribute('data-master-variant'); // "true", "false", or null
        var isOutOfStock = card.classList.contains('sold-out') || (card.querySelector('.button-add') && card.querySelector('.button-add').disabled);

        if (masterAttr === 'false') {
            // Always hide duplicate variants
            card.style.display = 'none';
        } else if (masterAttr === 'true' || masterAttr === null) {
            // Show master variants and null variants
            card.style.display = isOutOfStock ? 'none' : 'block';
        } else {
            // Fallback: show anything else
            card.style.display = 'block';
        }
    });
});
  // Get Template
var itemHtml = bcSfFilterTemplate.productGridItemHtml;

// Add Thumbnail
var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src']) : bcSfFilterConfig.general.no_image_url;
var itemThumbUrl2 = images.length > 1 ? this.optimizeImage(images[1]['src']) : bcSfFilterConfig.general.no_image_url;
var productImage = '';

if (images.length > 1) {
  productImage = '<img class="first-image lazyload" src="' + itemThumbUrl + '"> <img class="second-image lazyload" src="' + itemThumbUrl2 + '">';
} else {
  productImage = '<img src="' + itemThumbUrl + '">';
}

itemHtml = itemHtml.replace(/{{productImage}}/g, productImage);
itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

// Convert tags to lowercase for consistent checking
var tags = data.tags.map(tag => tag.toLowerCase());
var hidePriceQty = tags.includes('party exclusive'); // ✅ This is the key condition

// Add Price (handles sale / slash price)
var itemPriceHtml = '';
var tagsLower = data.tags.map(tag => tag.toLowerCase());

if (!tagsLower.includes('party exclusive') && !tagsLower.includes('collect in store------')) {

    // Use the selected or first available variant
    var firstVariant = data.selected_or_first_available_variant || data.variants[0];

    if (firstVariant.compare_at_price > firstVariant.price) {
        // On sale / slash price
        itemPriceHtml = `<span class="price-field regprice" style="color:black;">${this.formatMoney(firstVariant.price)}</span>
                         <span class="price-field compare" style="color:red; text-decoration: line-through;">${this.formatMoney(firstVariant.compare_at_price)}</span>`;
    } else {
        // Normal price
        itemPriceHtml = `<span class="price-field regprice">${this.formatMoney(firstVariant.price)}</span>`;
    }

} else {
    // Party Exclusive / Collect in Store: hide price
    itemPriceHtml = '';
}

// Inject price into template
itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

// BESTSELLER ICON (optional, you can uncomment if needed)
// var bestsellerIcon = '';
// if (data.tags.indexOf('Bestseller') > -1) {
//   bestsellerIcon += '<div class="badge-icon"><img src="//cdn.shopify.com/s/files/1/0042/7514/2759/t/13/assets/bestSeller.svg?92066"></div>';
// } else {
//   bestsellerIcon = '';
// }
// itemHtml = itemHtml.replace(/{{bestsellerIcon}}/g, bestsellerIcon);

// CHRISTMAS ICON (optional, you can uncomment if needed)
// var christmasIcon = '';
// if (data.tags.indexOf('Christmas') > -1) {
//   christmasIcon += '<div class="badge-icon"><img src="//cdn.shopify.com/s/files/1/0042/7514/2759/t/13/assets/christmas.svg?92106"></div>';
// } else {
//   christmasIcon = '';
// }
// itemHtml = itemHtml.replace(/{{christmasIcon}}/g, christmasIcon);

// BADGE LOGIC — UNTOUCHED
var newItemIcon = '';
var NEWITEMICON = $('.unique-new-icon').data('imgsrc');
var collection_handle = $('#col-handle').val();
// console.log('tags:', tags, 'includes summer sale:', tags.includes('Summer Sale 2026'));
if (tags.includes('exclusive sale 2025--')) {
  newItemIcon = ''; // Do nothing / hide
} else if (tags.includes('summer sale 2026---')) {
newItemIcon += badgeHTML('50% OFF');
} else if (tags.includes('collect in store')) {
  newItemIcon += badgeHTML('Melts');
  
} else if (tags.includes('freshness 2024--') && tags.includes('new---')) {
  newItemIcon += badgeHTML('50% OFF');
} else if (tags.includes('limited edition')) {
  newItemIcon += badgeHTML('Limited Edition', '10px');
} else if (tags.includes('new')) {
  newItemIcon += badgeHTML('New');
} else if (tags.includes('bestsellers')) {
  newItemIcon += badgeHTML('Bestseller');
} else if (tags.includes('leaving soon')) {
  newItemIcon += badgeHTML('Leaving Soon');
} else if (tags.includes('melts')) {
  newItemIcon += badgeHTML('Melts');
} else if (tags.includes('Summer Sale 2026---')) {
newItemIcon += badgeHTML('50% OFF');
} else {
  newItemIcon = '';
}
// Replace badge placeholder in item HTML
itemHtml = itemHtml.replace(/{{imgNewIcon}}/g, newItemIcon);

// Badge HTML generator function
function badgeHTML(text, fontSize = 'inherit') {
  return `
    <div class="c-product__badge false">
      <div class="badge_bkg"></div>
      <div class="badge-text nofocus" style="outline: none; font-size: ${fontSize};">${text}</div>
    </div>
  `;
}
  itemHtml = itemHtml.replace(/{{imgNewIcon}}/g, newItemIcon);


    //  PRODUCT VARIANT
  
  
//     var productId = data.variants[0].id;
//     itemHtml = itemHtml.replace(/{{productId}}/g, productId);
  
  	// PRODUCT TITLE  
//     var productVariantTitle = data.variants[0].title;
//     itemHtml = itemHtml.replace(/{{productVariantTitle}}/g, productVariantTitle);
  
  	// CART BUFFER  
//     var itemQty = $('.mini-cart-products[data-incartid="'+data.variants[0].id+'"]').data('incart');

//     itemQty = (isNaN( itemQty) ? 0 :  itemQty);

//     itemHtml = itemHtml.replace(/{{itemQty}}/g,  itemQty);
  
//   	var itemQuantity = data.variants[0].inventory_quantity;  
//   	var itemCount = itemQuantity - itemQty;
//   	var productButton = '';
  
//     if(data.tags.indexOf('Collect in Store') > -1) {
//       productButton += '<button class="fas-btn"><a href="/pages/shops">Find a Store</a></button>'
//     } else {
//       if(data.tags.indexOf('Online Exclusive') > -1) {
//         if (itemCount <= 1) { 
//           productButton += '<button class="button-add disabled" disabled>OUT OF STOCK</button>'
//         } else {
//           productButton += '<button class="button-add" >Add To Cart</button>'
//         }
//       } else if(data.tags.indexOf('Fast Moving') > -1) {
//         if (itemCount <= 4) { 
//           productButton += '<button class="button-add disabled" disabled>OUT OF STOCK</button>'
//         } else {
//           productButton += '<button class="button-add" >Add To Cart</button>'
//         }
//       } else {
//         if (itemCount <= 2) { 
//           productButton += '<button class="button-add disabled" disabled>OUT OF STOCK</button>'
//         } else {
//           productButton += '<button class="button-add" >Add To Cart</button>'
//         }
//       }
//     }
  
  
  
  // CART BUFFER  
//   var itemQty = $('.mini-cart-products[data-incartid="'+data.variants[0].id+'"]').data('incart');

//   itemQty = (isNaN( itemQty) ? 0 :  itemQty);

//   itemHtml = itemHtml.replace(/{{itemQty}}/g,  itemQty);

//   var itemQuantity = data.variants[0].inventory_quantity;  
//   var itemCount = itemQuantity - itemQty;

  
    //   FOR NEW COLLECTION ADD TO CART

      var productButton = '';
      var productId = '';
      var itemPrice = '';
      var productVariantTitle = '';


  
      for (var i = 0; i < data['variants'].length; i++) {
        var itemQty = $('.mini-cart-products[data-incartid="'+data.variants[i].id+'"]').data('incart');
        itemQty = (isNaN( itemQty) ? 0 :  itemQty);
        
        //   var itemQuantity = data.variants[0].inventory_quantity;  
        //   var itemCount = itemQuantity - itemQty;

//         if (data['variants'][i].available) {
          
        
var Datavar = data.variants[i];
var tagsLower = data.tags.map(tag => tag.toLowerCase());
var priceEL = '';

// Only set priceEL if NOT Party Exclusive or Collect in Store
if (!tagsLower.includes('party exclusive') && !tagsLower.includes('collect in store--------')) {

    // Freshness 2026 slash price logic
    if(tagsLower.includes('freshness 2026') && Datavar.compare_at_price > Datavar.price){
        priceEL = `<span class="price-field regprice" style="color:black">${this.formatMoney(Datavar.price)}</span> 
                   <span class="price-field compare" style="color:red; text-decoration: line-through;">${this.formatMoney(Datavar.compare_at_price)}</span>`;
    } else {
        // Normal price display
        priceEL = `<span class="price-field regprice">${this.formatMoney(Datavar.price)}</span>`;
    }
} else {
    // Party Exclusive / Collect in Store: hide price
    priceEL = '';
}

if (data.tags.indexOf('Party Exclusive') > -1) {
  productButton = '';
  priceEL = ''; // ✅ still hides the price
  // Show clickable PARTY EXCLUSIVE button linking to product
  productButton += '<a href="' + data.url + '" class="fas-btn" style="background-color: #6F7378; color: white; opacity: 0.7; border: none; display: inline-block; text-align: center; padding: 10px 20px; text-decoration: none;">PARTY EXCLUSIVE</a>';
} else if (data.tags.indexOf('Collect in Store') > -1) {
    var firstVariant = data.selected_or_first_available_variant || data.variants[0];

    // Show first variant price
    priceEL = `<span class="price-field regprice">${this.formatMoney(firstVariant.price)}</span>`;

    // Show weight
    productVariantTitle = firstVariant.title; // <-- this is the missing piece

    // Replace Add to Cart with IN-STORE EXCLUSIVE button
    productButton = '';
    productButton += '<a href="' + data.url + '" class="fas-btn" style="background-color: #6F7378; color: white; opacity: 0.7; border: none; display: inline-block; text-align: center; padding: 10px 20px; text-decoration: none;">IN-STORE EXCLUSIVE</a>';

} else {
            if(data.tags.indexOf('Online Exclusives') > -1 || data.tags.indexOf('Short Shelf Life') > -1 || data.tags.indexOf('Seasonal') > -1 || data.tags.indexOf('Freshness sale') > -1){
//               var testvarqty = data.variants[i].inventory_quantity - 1;
              var itemQuantity = data.variants[i].inventory_quantity - 0;  
              var itemCount = itemQuantity - itemQty;
              if(itemCount > 0){ 

                productId = '';
                productId = data.variants[i].id

                productVariantTitle = '';
                productVariantTitle = data.variants[i].title;

                itemPrice = '';
                itemPrice = `<span class="price-field regprice">${this.formatMoney(data.variants[i].price)}</span>`

                productButton = '';
                productButton += '<button class="button-add" >Add To Bag</button>'

                break;

              }else{

                productId = '';
                productId = data.variants[i].id

                itemPrice = '';
                itemPrice += `<span class="price-field regprice">${this.formatMoney(data.variants[i].price)}</span>`
                
                productVariantTitle = '';
                productVariantTitle = data.variants[i].title;
                
				productButton = '';
                productButton += '<button class="button-add disabled" disabled>OUT OF STOCK</button>'
                
              }
            }else if(data.tags.indexOf('Fast Moving') > -1) {
              
              var itemQuantity = data.variants[i].inventory_quantity - 4;  
              var itemCount = itemQuantity - itemQty;
              if(itemCount > 0){ 

                productId = '';
                productId = data.variants[i].id

                productVariantTitle = '';
                productVariantTitle = data.variants[i].title;

                itemPrice = '';
                itemPrice = `<span class="price-field regprice">${this.formatMoney(data.variants[i].price)}</span>`

                productButton = '';
                productButton += '<button class="button-add" >Add To Bag</button>'

                break;

              }else{

                productId = '';
                productId = data.variants[i].id

                itemPrice = '';
                itemPrice += `<span class="price-field regprice">${this.formatMoney(data.variants[i].price)}</span>`

                productVariantTitle = '';
                productVariantTitle = data.variants[i].title;
                
                productButton = '';
                productButton += '<button class="button-add disabled" disabled>OUT OF STOCK</button>'
              }
            
            }else {
              
              var itemQuantity = data.variants[i].inventory_quantity - 0;  
              var itemCount = itemQuantity - itemQty;
              if(itemCount > 0){ 

                productId = '';
                productId = data.variants[i].id

                productVariantTitle = '';
                productVariantTitle = data.variants[i].title;

                itemPrice = '';
                itemPrice = `<span class="price-field regprice">${this.formatMoney(data.variants[i].price)}</span>`

                productButton = '';
                productButton += '<button class="button-add" >Add To Bag</button>'

                break;

              }else{

                productId = '';
                productId = data.variants[i].id

                itemPrice = '';
                itemPrice += `<span class="price-field regprice">${this.formatMoney(data.variants[i].price)}</span>`

                productVariantTitle = '';
                productVariantTitle = data.variants[i].title;
				
                productButton = '';
                productButton += '<button class="button-add disabled" disabled>OUT OF STOCK</button>'
                
              }
              
            }
            
          }
//         }
      }

    itemHtml = itemHtml.replace(/{{itemQty}}/g,  itemQty);
    itemHtml = itemHtml.replace(/{{productVariantTitle}}/g, productVariantTitle);
    itemHtml = itemHtml.replace(/{{productButton}}/g,  productButton);
    itemHtml = itemHtml.replace(/{{productId}}/g, productId); 
     
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, priceEL);

    //   END OF NEW COLLECTION ADD TO CART
  
  

//   	itemHtml = itemHtml.replace(/{{itemCount}}/g,  itemCount);
  
  	// PRODUCT SHORT DESCRIPTION
// Read metafields injected by Liquid
var metaEl = $('.metafields-data[data-product-id="' + data.id + '"]');
var metaData = '';

if (metaEl.length) {
    metaData = metaEl.data('metadata') || '';
}

// Inject into template
itemHtml = itemHtml.replace(/{{itemMetadata}}/g, metaData);
  	// PRODUCT URL  
    var dataUrl = data.url;

    itemHtml = itemHtml.replace(/{{dataUrl}}/g, dataUrl);
  
  	// PRODUCT PRICE WITHOUT CURRENCY  
    var dataPrice = data.price_min/10000;

    itemHtml = itemHtml.replace(/{{dataPrice}}/g, dataPrice);
  
  	// PRODUCT MASTER ID 
    var dataMasterId = data.id;

    itemHtml = itemHtml.replace(/{{dataMasterId}}/g, dataMasterId);
  
	// PRODUCT TYPE
  
  	var dataType = data.product_type;

  	itemHtml = itemHtml.replace(/{{dataType}}/g, dataType);
  
    // Add soldOut class
    var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
  
    // Add onSale class
    var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
  
    // Add soldOut Label
    var itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

    // Add onSale Label
    var itemSaleLabelHtml = onSale ? bcSfFilterTemplate.saleLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);

    // Add Vendor
    var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemIsMasterVariant}}/g, data.is_master_variant);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
  
  

  
    
  
  

    if(data.tags.indexOf('Gift Set Exclusive') > -1){
      var itemHtml = '';
      return itemHtml;
    }else{
      return itemHtml;
    }
};

// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function(data) {
    // // Add Description
    // var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
    // // Truncate by word
    // itemDescription = (itemDescription.split(" ")).length > 51 ? itemDescription.split(" ").splice(0, 51).join(" ") + '...' : itemDescription.split(" ").splice(0, 51).join(" ");
    // // Truncate by character
    // itemDescription = itemDescription.length > 350 ? itemDescription.substring(0, 350) + '...' : itemDescription.substring(0, 350);
    // itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
};

/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    if (this.getSettingValue('general.paginationType') == 'default') {
        // Get page info
        var currentPage = parseInt(this.queryParams.page);
        var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

        // If it has only one page, clear Pagination
        if (totalPage == 1) {
            jQ(this.selector.bottomPagination).html('');
            return false;
        }

        if (this.getSettingValue('general.paginationType') == 'default') {
            var paginationHtml = bcSfFilterTemplate.paginateHtml;

            // Build Previous
            var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
            previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
            paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

            // Build Next
            var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
            nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
            paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

            // Create page items array
            var beforeCurrentPageArr = [];
            for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
                beforeCurrentPageArr.unshift(iBefore);
            }
            if (currentPage - 4 > 0) {
                beforeCurrentPageArr.unshift('...');
            }
            if (currentPage - 4 >= 0) {
                beforeCurrentPageArr.unshift(1);
            }
            beforeCurrentPageArr.push(currentPage);

            var afterCurrentPageArr = [];
            for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
                afterCurrentPageArr.push(iAfter);
            }
            if (currentPage + 3 < totalPage) {
                afterCurrentPageArr.push('...');
            }
            if (currentPage + 3 <= totalPage) {
                afterCurrentPageArr.push(totalPage);
            }

            // Build page items
            var pageItemsHtml = '';
            var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
            for (var iPage = 0; iPage < pageArr.length; iPage++) {
                if (pageArr[iPage] == '...') {
                    pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
                } else {
                    pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
                }
                pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
                pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
            }
            paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

            jQ(this.selector.bottomPagination).html(paginationHtml);
        }
    }
};

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content 
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Build Display type (List / Grid / Collage)
// BCSfFilter.prototype.buildFilterDisplayType = function() {
//     var itemHtml = '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="change-view bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
//     itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="change-view bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
//     jQ(this.selector.topDisplayType).html(itemHtml);

//     // Active current display type
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('active');
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('active');
//     if (this.queryParams.display == 'list') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('active');
//     } else if (this.queryParams.display == 'grid') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('active');
//     }
// };

/************************** END BUILD TOOLBAR **************************/

// Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData=function(data){for(var k=0;k<data.length;k++){data[k]['images']=data[k]['images_info'];if(data[k]['images'].length>0){data[k]['featured_image']=data[k]['images'][0]}else{data[k]['featured_image']={src:bcSfFilterConfig.general.no_image_url,width:'',height:'',aspect_ratio:0}}data[k]['url']='/products/'+data[k].handle;var optionsArr=[];for(var i=0;i<data[k]['options_with_values'].length;i++){optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options']=optionsArr;data[k]['price_min']*=100,data[k]['price_max']*=100,data[k]['compare_at_price_min']*=100,data[k]['compare_at_price_max']*=100;data[k]['price']=data[k]['price_min'];data[k]['compare_at_price']=data[k]['compare_at_price_min'];data[k]['price_varies']=data[k]['price_min']!=data[k]['price_max'];var firstVariant=data[k]['variants'][0];if(getParam('variant')!==null&&getParam('variant')!=''){var paramVariant=data.variants.filter(function(e){return e.id==getParam('variant')});if(typeof paramVariant[0]!=='undefined')firstVariant=paramVariant[0]}else{for(var i=0;i<data[k]['variants'].length;i++){if(data[k]['variants'][i].available){firstVariant=data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant']=firstVariant;for(var i=0;i<data[k]['variants'].length;i++){var variantOptionArr=[];var count=1;var variant=data[k]['variants'][i];var variantOptions=variant['merged_options'];if(Array.isArray(variantOptions)){for(var j=0;j<variantOptions.length;j++){var temp=variantOptions[j].split(':');data[k]['variants'][i]['option'+(parseInt(j)+1)]=temp[1];data[k]['variants'][i]['option_'+temp[0]]=temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options']=variantOptionArr}data[k]['variants'][i]['compare_at_price']=parseFloat(data[k]['variants'][i]['compare_at_price'])*100;data[k]['variants'][i]['price']=parseFloat(data[k]['variants'][i]['price'])*100}data[k]['description']=data[k]['content']=data[k]['body_html']}return data};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
  data.forEach(function(product) {
    if (product.tags.includes('party exclusive')) {
      setTimeout(function() {
        var card = $('.collection-card[data-id="' + product.id + '"]');
        
        // Hide price and add-to-cart
        card.find('.product-price').hide();      
        card.find('.add-to-cart').hide();        

        // Remove any span/div/etc. inside the card that contains just '/'
        card.find('*').each(function() {
          var text = $(this).text().trim();
          if (text === '/' || text === '/100g' || text === ' / ' || text.match(/^\/ ?\d*g$/i)) {
            $(this).remove(); // Remove the element if it only contains a slash or similar
          } else {
            // Remove slashes from within the text (e.g., '₱300 / 100g')
            var cleaned = text.replace(/ ?\/ ?\d*g?/gi, '').replace(/ ?\/ ?/g, '');
            if (cleaned !== text) {
              $(this).text(cleaned);
            }
          }
        });

      }, 100);
    }
  });
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  // if(typeof track_product_impression === 'function') {
  //   track_product_impression(data.products)
  // }

  if(typeof(track_product_impression) === 'function') {
    var products = data.products.filter(product => product.available);
    if(products.length > 0) {
      track_product_impression(products)
    }
  }
  
// START ITEM COUNTS

var from = this.queryParams.page == 1 ? this.queryParams.page : (this.queryParams.page - 1) * this.queryParams.limit + 1;
var to = from + data.products.length - 1;
if (to > data.total_product) to = data.total_product;
//   jQ("#esViewingText").html('Showing 1 to ' + to + ' of ' + data.total_product);
jQ('#sort-total-products').text(data.total_product + ' Results');
jQ('#sort-total-products2').text(data.total_product);
jQ('#sort-total-products3').text(data.total_product);
  
// END ITEM COUNTS

// START CHANGE TEXTS

$('select option:contains("Date, New to Old")').text('Newest');
$('select option:contains("Best Selling")').text('Best Sellers');
$('select option:contains("Lowest Price")').text('Price Low to High');
$('select option:contains("Highest Price")').text('Price High to Low');
$('select option:contains("Featured")').text('Best Matches');

// END CHANGE TEXTS

// START FILTER CUSTOMIZED ANIMATION AND EFFECTS

$('.bc-sf-filter-block-title span').addClass('up');
$('.bc-sf-filter-block-content').css('display', 'none');

if ($('.bc-sf-filter-block-title span').hasClass('up')) {
    $('.bc-sf-filter-block-title').addClass('up');
} else {
    $('.bc-sf-filter-block-title').removeClass('up');
}

$('.bc-sf-filter-block-title span').click(function(){
    if ($(this).hasClass('up')) {
        $(this).parent().parent().removeClass('up');
    } else {
        $(this).parent().parent().addClass('up');
    }
});

if ($('.filter-bar .bc-sf-filter-selection-wrapper').length == 0) {
    $('.bc-sf-filter-selection-wrapper').appendTo('.filter-bar')
}

// END FILTER CUSTOMIZED ANIMATION AND EFFECTS

// START RESET BUTTON MARKUP AND FUNCTION

if ($('.reset-button').length == 0) {
    $( "#bc-sf-filter-tree" ).prepend( '<button class="reset-button" onclick="clearAllFilterOptions(event)">RESET</button>' );
}

// END RESET BUTTON MARKUP AND FUNCTION

// START LOCATION RELOADS

$('.bc-sf-filter-option-item.bc-sf-filter-option-label').click(function(){
    location.reload();
});

$('.reset-button').click(function(){
    location.reload();
});

$('.collection-sort__input').change(function(){
    location.reload();
});

$('.selected-item.bc-sf-filter-option-label').click(function(){
    location.reload();
});
  
// END LOCATION RELOADS

// START MOBILE FILTER

// if ($(window).width() <= 768) {
//     $('.collection-description').appendTo('.lush-collections');
// }

if ($(window).width() <= 767) {
    $('#bc-sf-filter-tree').appendTo('.mob-filter-main');
    $('#sort-total-products').clone().appendTo('.mob-filter .page-width');
}

$('#bc-sf-filter-tree-mobile button').click(function(e){
    $('#mob-filter').css('top', '0px');
    $('#bc-sf-filter-tree').css('display', 'block');
    $('.bg-overlay').css('display', 'block');
    e.stopPropagation();
});
$(document).click(function(e) {
    if ($(e.target).is("#mob-filter *") === false) {
      $("#mob-filter").css('top', '-100%');
      $('#bc-sf-filter-tree').css('display', 'none');
      $('.bg-overlay').css('display', 'none');
    }
});
$('.mob-filter .filter-header a').click(function(){
    $('#mob-filter').css('top', '-100%');
    $('#bc-sf-filter-tree').css('display', 'none');
    $('.bg-overlay').css('display', 'none');
});

// END MOBILE FILTER
  
// START ARTICLE CARD
  
  	var articleCard = '';
    var artUrl = $('#article-link').data('arturl');
    var artImg = $('#article-img').data('artimg');
    var artTitle = $('#article-title').data('arttitle'); 
  	var artPos = $('#article-position').data('artpos'); 
  	var artButton = $('#article-button').data('artbutton'); 

    if( artImg != undefined && $('.article-card').length == 0 ){
      articleCard = '<div class="article-card">' +
                      '<div class="article-image" style="background: url('+ artImg +') no-repeat center; background-size: cover;">' +             
                      '<div class="article-overlay">' +
                      '</div>' +
                      '<div class="article-title">' +
                          '<h1>'+ artTitle +'</h1>' +
                      '</div>' +
                      '<div class="article-button">' +
                          '<a href= "'+ artUrl +'">'+ artButton +'</a>' +
                      '</div>' +
                      '</div>' +
                  '</div>';
      $(articleCard).insertAfter($('#bc-sf-filter-products .collection-card:eq('+ artPos +')'))    
    } else {
      var articleCard = '';
    };
  
// END ARTICLE CARD
  
// START ADD TO CART 
  
  $('.button-add').click(function(e){
    var pid = parseInt($(this).parent().data('id'));
     console.log(pid)
        addCart(pid);
    // jQuery.ajax({
    //   type: 'POST',
    //   url: '/cart/add.js',
    //   data: {
    //     quantity: 1,
    //     id: pid
    //   },
    //   dataType: 'json',           
    //   success: function() {
    //     $modal.show();
    //     $loader.show();
    //     setTimeout(function() {
    //       $modal.hide();
    //       $loader.hide();
    //       $message.show();
    //     }, 2000)
    //     setTimeout(function(){
    //       $message.hide();
    //       location.reload();
    //     }, 6000)
    //   },
    //   error: function() {
    //     $modal.show();
    //     $loader.show();
    //     setTimeout(function() {
    //       $modal.hide();
    //       $loader.hide();
    //       $ofsmessage.show();
    //     }, 2000)
    //     setTimeout(function(){
    //       $ofsmessage.hide();
    //       location.reload();
    //     }, 6000)
    //   }
    // });  
  });
  
// END ADD TO CART 
  
// START WISHLIST
 
  window._swat.fetch( function(r) {
    for (i = 0; i < r.length; i++) {
      var aa = r[i].epi;
      wishListIcon = $('.collection-card').find('.wishlist[data-id="'+aa+'"]').find('i').addClass('fas').removeClass('far');
    }
  });

  
  $('.wishlist').click(function(e){
    e.preventDefault();
    var $this = $(this),
        heartIcon = $this.children().children(),
        wishId = $this.data('id'),
        dataUrl = $this.data('url'),
        wishUrl = "https://lush.com.ph" + dataUrl,
        wishCount = $this.data('count'),
        wishImg = $this.data('img'),
        wishPrice = $this.data('price'),
        wishMid = $this.data('mid');

    window._swat.addToWishList(
      {
        "epi": wishId,
        "du": wishUrl,
        "empi": wishMid,
        "iu" : wishImg,
        "pr": wishPrice,
        "stk": wishCount,
        "variants": ""
      },
      function(r) {
        heartIcon.removeClass('far');
        heartIcon.addClass('fas');
      }
    );
  });
  
// END WISHLIST
function hideDuplicateVariants() {
    setTimeout(function() {
        const groups = {};

        // Group all collection cards by master ID
        $('.collection-card').each(function() {
            const $card = $(this);
            const masterId = $card.data('master-id') || $card.data('id');
            if (!groups[masterId]) groups[masterId] = [];
            groups[masterId].push($card);
        });

        // Process each group
        Object.values(groups).forEach(group => {
            let masterCard = null;
            let firstInStock = null;

            group.forEach($card => {
                // Determine master and stock status
                const masterAttr = $card.attr('data-master-variant'); // "true", "false", or null
                const isOutOfStock = $card.hasClass('sold-out') || ($card.find('.button-add').length && $card.find('.button-add').prop('disabled'));

                if (masterAttr === 'true') masterCard = $card;
                if (!isOutOfStock && !firstInStock) firstInStock = $card;
            });

            // Hide duplicates and out-of-stock master, show nulls always unless out of stock
            group.forEach($card => {
                const masterAttr = $card.attr('data-master-variant'); // "true", "false", or null
                const isOutOfStock = $card.hasClass('sold-out') || ($card.find('.button-add').length && $card.find('.button-add').prop('disabled'));

                if (masterAttr === 'false') {
                    // Always hide duplicates
                    $card.hide();
                } else if (masterAttr === 'true') {
                    // Master: hide if out of stock and show first in-stock duplicate
                    if (isOutOfStock && firstInStock) {
                        $card.hide();
                        firstInStock.show();
                    } else {
                        $card.show();
                    }
                } else if (masterAttr === null) {
                    // Null variants: always show unless out of stock
                    $card.css('display', isOutOfStock ? 'none' : 'block');
                } else {
                    // Fallback: show
                    $card.show();
                }
            });
        });
    }, 1000);
}

$(document).ready(function() {
    hideDuplicateVariants();

    $(document).on('click', '.load-more-button', function() {
        setTimeout(hideDuplicateVariants, 100);
    });
});
};

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
